import { Directive, ElementRef, inject, Input, TemplateRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import type { SelectContext } from '../../types';
import { SELECT_CONTROLLER } from '../../types';
import type { TriggerContext } from './types';

@Directive({
  standalone: true,
  selector: '[rtSelectTrigger]',
  exportAs: 'triggerDir',
})
export class Select2TriggerDirective<Select extends SelectContext> {
  public static ngTemplateContextGuard<Select extends SelectContext>(
    dir: Select2TriggerDirective<Select>,
    ctx: unknown,
  ): ctx is TriggerContext<Select> {
    return true;
  }
  @Input() public rtSelectTrigger: Select | '';

  private focusableEl?: HTMLElement;
  private untilDestroyed = takeUntilDestroyed();
  private selectController = inject(SELECT_CONTROLLER);

  constructor(public templateRef: TemplateRef<TriggerContext<Select>>) {}

  public ngOnInit() {
    this.selectController.focusTrigger$.pipe(this.untilDestroyed).subscribe(() => {
      this.focusableEl?.focus();
    });
  }

  public setFocusable(element: ElementRef | HTMLElement) {
    this.focusableEl = element instanceof ElementRef ? element.nativeElement : element;
  }
}
